(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;

  function initReveals(root) {
    root.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      if (!io || reduce) { el.classList.add('mt-visible'); return; }
      io.observe(el);
    });
  }

  function initTypewriter(root) {
    root.querySelectorAll('[data-mt-type]').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1';
      var words = []; try { words = JSON.parse(el.getAttribute('data-mt-type')); } catch (e) {}
      words = words.filter(function (w) { return w && w.trim(); });
      if (words.length < 2 || reduce) return;
      var i = 0, txt = words[0], del = true, pause = 1600;
      function tick() {
        if (!document.body.contains(el)) return;
        if (del) {
          txt = txt.slice(0, -1); el.textContent = txt;
          if (!txt.length) { del = false; i = (i + 1) % words.length; }
          setTimeout(tick, 45);
        } else {
          txt = words[i].slice(0, txt.length + 1); el.textContent = txt;
          if (txt === words[i]) { del = true; setTimeout(tick, pause); } else setTimeout(tick, 85);
        }
      }
      setTimeout(tick, pause);
    });
  }

  function initTilt(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    root.querySelectorAll('[data-mt-tilt]').forEach(function (stage) {
      if (stage.dataset.mtInit) return; stage.dataset.mtInit = '1';
      var card = stage.querySelector('.mt-hero__card'); if (!card) return;
      var max = parseFloat(stage.getAttribute('data-mt-tilt')) || 8;
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        card.style.transform = 'rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg)';
      });
      stage.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  function initColors(root) {
    root.querySelectorAll('[data-mt-colors]').forEach(function (box) {
      if (box.dataset.mtInit) return; box.dataset.mtInit = '1';
      var sw = box.querySelectorAll('.mt-colors__swatch'), imgs = box.querySelectorAll('.mt-colors__stage img'), name = box.querySelector('.mt-colors__name');
      sw.forEach(function (b, idx) {
        b.addEventListener('click', function () {
          sw.forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === idx); });
          if (name) name.textContent = b.getAttribute('data-name');
        });
      });
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('[data-mt-hot]').forEach(function (box) {
      if (box.dataset.mtInit) return; box.dataset.mtInit = '1';
      var spots = box.querySelectorAll('.mt-hot__spot'), items = box.querySelectorAll('.mt-hot__item');
      function act(n) {
        spots.forEach(function (s) { s.setAttribute('aria-expanded', s.dataset.i === n ? 'true' : 'false'); });
        items.forEach(function (it) { it.classList.toggle('is-active', it.dataset.i === n); });
      }
      spots.forEach(function (s) { s.addEventListener('click', function () { act(s.dataset.i); }); s.addEventListener('mouseenter', function () { act(s.dataset.i); }); });
      items.forEach(function (it) { it.addEventListener('mouseenter', function () { act(it.dataset.i); }); it.addEventListener('click', function () { act(it.dataset.i); }); });
      if (spots[0]) act(spots[0].dataset.i);
    });
  }

  function initFaq(root) {
    root.querySelectorAll('.mt-faq__q').forEach(function (q) {
      if (q.dataset.mtInit) return; q.dataset.mtInit = '1';
      q.addEventListener('click', function () {
        var it = q.closest('.mt-faq__item'); var open = !it.classList.contains('is-open');
        it.classList.toggle('is-open', open); q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initProduct(root) {
    root.querySelectorAll('[data-mt-product]').forEach(function (box) {
      if (box.dataset.mtInit) return; box.dataset.mtInit = '1';
      var main = box.querySelector('.mt-prod__main img');
      var thumbs = box.querySelectorAll('.mt-prod__thumb');
      function show(src, alt) { if (!main) return; main.style.opacity = 0; setTimeout(function () { main.src = src; main.alt = alt || ''; main.style.opacity = 1; }, 150); }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true'); show(t.dataset.src, t.dataset.alt);
        });
      });
      var dataEl = box.querySelector('[data-mt-variants]'); if (!dataEl) return;
      var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = box.querySelector('input[name="id"]'), price = box.querySelector('[data-mt-price]'), btn = box.querySelector('[data-mt-add]');
      var fmt = box.getAttribute('data-mt-money');
      function money(c) {
        var v = (c / 100).toFixed(2);
        return fmt ? fmt.replace(/\{\{\s*amount[^}]*\}\}/, v) : v;
      }
      function update() {
        var sel = Array.prototype.map.call(box.querySelectorAll('.mt-prod__opt'), function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; } return; }
        if (idInput) idInput.value = v.id;
        if (price) price.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout; }
        if (v.featured_image && v.featured_image.src) show(v.featured_image.src, v.featured_image.alt);
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u);
      }
      box.querySelectorAll('.mt-prod__opt input').forEach(function (inp) { inp.addEventListener('change', update); });
    });
  }

  function initAll(root) {
    root = root && root.querySelectorAll ? root : document;
    initReveals(root); initTypewriter(root); initTilt(root); initColors(root); initHotspots(root); initFaq(root); initProduct(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
